import React, { Component } from 'react'
import { Table, Tooltip, Modal, Button, Badge, Avatar, Collapse, Select, Form, Input } from 'antd'
import Currency from 'react-currency-formatter';
import { connect } from 'dva'
import { Link } from 'dva/router'
import config from '../../utils/config'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import { all } from '../../services/restApi'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const ButtonGroup = Button.Group;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const Option = Select.Option;

class Employee extends Component {

    constructor (props) {
        super(props);

        this.state = {
            hotels: []
        };

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        let query = {};

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }


    loadMore () {
        if (this.props.employee.skip < this.props.employee.total_items) {

            let query = {};
            if (this.state.currentHotel)
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

            this.props.dispatch({type: 'employee/query', payload: {
                where: query,
                skip: this.props.employee.skip,
                limit: this.props.employee.limit,
                count: 1,
                order: '-createdAt'
            }});
        }
    }

    delete_item (item) {

        let dispatch = this.props.dispatch

        confirm({
            title: '¿Estás seguro que deseas eliminar el empleado?',
            onOk () {
                dispatch({type: 'employee/removeItem', payload: item});
            }
        })
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }

    /**
    * Búsqueda
    */
    search (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query = this.state.query;
            query = _.omit(query, ['hotel', 'name', 'rfc', 'curp', 'imss'])

            if (values.hotel && values.hotel.key)
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};

            if (values.name)
                query.name = {$regex: '(?i)' + values.name};

            if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
                query.hotel = {$in: this.props.app.user.hotels}
            }


            this.setState({query: query});

            this.props.dispatch({type: 'employee/filter', payload: {
                where: query,
                skip: 0,
                limit: this.props.employee.limit,
                count: 1,
                order: '-createdAt'
            }});
        })
    }

    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Empleados

                        <div className="pull-right">
                            <Button type='primary'>
                                <Link to="/employees/new-employee"><Icon name="plus" /> Agregar nuevo empleado</Link>
                            </Button>
                        </div>
                    </h1>
                </section>

                <section className="content">
                    <Collapse defaultActiveKey={['0']} className="marginBottom20">
                        <Panel header="Búsqueda" key="1">
                            <Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                    {!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel">
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-3">
                                        <FormItem label="Nombre">
                                            {this.props.form.getFieldDecorator('name')(<Input size='large' placeholder="Escribir el nombre" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="RFC">
                                            {this.props.form.getFieldDecorator('rfc')(<Input size='large' placeholder="Escribir el RFC" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="CURP">
                                            {this.props.form.getFieldDecorator('curp')(<Input size='large' placeholder="Escribir el CURP" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="No. IMMS">
                                            {this.props.form.getFieldDecorator('imss')(<Input size='large' placeholder="Escribir el no. de IMSS" />)}
                                        </FormItem>
                                    </div>
                                </div>

                                <div className="row text-center paddingBottom30">
                                    <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Buscar...
                                    </Button>
                                </div>
                            </Form>
                        </Panel>
                    </Collapse>

                    <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="table-responsive table">

                                        <InfiniteScroll
                                            padding={50}
                                            throttle={100}
                                            onScroll={() => this.loadMore()}>

                                            <Table 
                                                dataSource={this.props.employee.employees} 
                                                rowKey="objectId" size="middle" 
                                                size="middle" 
                                                loading={this.props.app.loadingTable} 
                                                pagination={false}>
                                                
                                                <Column key="picture"
                                                    render={(item) => (
                                                        <span>
                                                            {!item.picture ?
                                                                <Avatar size="large" src="assets/img/avatar5.png" /> :
                                                                <Avatar size="large" src={config.externalUrl + 'uploads/users/' + item.picture} />
                                                            }
                                                        </span>
                                                    )}
                                                />
                                                <Column title="Nombre" key="name" render={(item) => (
                                                    <span>
                                                        <span className="color-primary">{item.name}</span><br />
                                                        <small style={{textTransform: 'capitalize'}}>{item.job ? item.job : ''}</small><br />
                                                        <small>{item.email ? item.email : ''}</small>
                                                    </span>
                                                )} />
                                                <Column title="Empleado" key="hotel" render={(item) => (
                                                    <span>{item.type === 'hotel' && item.hotel ? item.hotel.name : 'TRIE'}</span>
                                                )} />
                                                <Column title="RFC" key="rfc" render={(item) => (
                                                    <span style={{textTransform: 'uppercase'}}>{item.rfc}</span>
                                                )} />
                                                <Column title="CURP" key="curp" render={(item) => (
                                                    <span style={{textTransform: 'uppercase'}}>{item.curp}</span>
                                                )} />
                                                {/*<Column title="Teléfono" dataIndex="phone" key="phone" />*/}
                                                <Column title="No. Seguro Social" dataIndex="imss" key="imss" />
                                                <Column title="Sueldo diario" key="salary" render={(item) => (
                                                    <Currency quantity={item.salary ? item.salary : 0} currency="USD" />
                                                )}/>
                                                <Column title="Periodicidad" dataIndex="periodicity" key="periodicity" />
                                                <Column title="Fecha Alta" key="alta_employee" render={(item) => (
                                                    <span>
                                                        {item.alta_employee
                                                            ? <span>{moment(item.alta_employee.iso).format('DD/MM/YYYY')}</span>
                                                            : ''
                                                        }
                                                    </span>
                                                )}/>
                                                <Column title="Status" key="active" width={82} render={(item) => (
                                                    <span>
                                                        {item.active
                                                            ? <span><Badge status="success" /><small>Activo</small></span>
                                                            : <span><Badge status="warning" /><small>Suspendido</small></span>
                                                        }
                                                    </span>
                                                )}/>
                                                <Column title="Acciones" key="action" width={90}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            <ButtonGroup>
                                                                <Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link to={`/employees/details/${item.objectId}`}><Icon name="edit" /></Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                <Tooltip placement="bottom" title="Eliminar">
                                                                    <Button>
                                                                        <Link onClick={() => { this.delete_item(item) }}><Icon name="trash" /></Link>
                                                                    </Button>
                                                                </Tooltip>
                                                            </ButtonGroup>
                                                        </span>
                                                    )}
                                                />
                                            </Table>        
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(({employee, app}) => ({employee, app}))(Form.create()(Employee))


// WEBPACK FOOTER //
// ./src/components/employees/index.js